import React, { useState } from "react";
import { useDispatch, useSelector } from "types/store";
import { Button } from "aible";
import * as chatGPTReducer from "containers/ChatGPT/reducer";
import * as viewReducer from "containers/View/reducer";
import styles from "./style.module.css";
import Tooltip from "components/Inputs/Tooltip";
const AgentIqToolOptionsList = () => {
    const agentIqToolOptions = chatGPTReducer.getAgentIQToolOptions();
    const agentIqCustomToolOptions = useSelector((state) => chatGPTReducer.getAgentIQStepByStepTools(state));
    // Whether the user has clicked an agent button
    // Used because we want to deselect the default agents on the first click of the user agents
    // We don't want to deselect again this after the user clicks once
    const [deselectDefaults, setDeselectDefaults] = useState(true);
    return (React.createElement("div", null,
        React.createElement("div", { className: styles.agentIqToolsListContainer }, agentIqToolOptions.map((option) => {
            return React.createElement(AgentIqToolOptionButton, { key: `toolOption_${option?.id}_${option.blueprint_id}`, type: option });
        })),
        React.createElement(AgentIqSelectAgent, { deselectDefaults: deselectDefaults, updateDeselectDefaults: setDeselectDefaults })));
};
const AgentIqSelectAgent = ({ deselectDefaults, updateDeselectDefaults }) => {
    const agentIqCustomToolOptions = useSelector((state) => chatGPTReducer.getAgentIQStepByStepTools(state));
    const options = useSelector((state) => chatGPTReducer.getAgentIQToolsAgentsOptions(state));
    if (!options?.length && !agentIqCustomToolOptions?.length) {
        return null;
    }
    return (React.createElement("div", { className: styles.agentIqToolSelectWrapper },
        React.createElement("div", { className: styles.agentIqToolSelectLabel }, "Available agents:"),
        React.createElement("div", { className: styles.agentIqToolSelect },
            agentIqCustomToolOptions.map((option) => {
                return React.createElement(AgentIqToolOptionButton, { type: option, key: option?.label + "_" + option?.executionId });
            }),
            options?.map((o) => {
                return (React.createElement(AgentIqTooltipButton, { option: o, deselectDefaults: deselectDefaults, updateDeselectDefaults: updateDeselectDefaults }));
            }))));
};
const AgentIqTooltipButton = ({ option, deselectDefaults, updateDeselectDefaults }) => {
    const dispatch = useDispatch();
    const chatApps = useSelector((state) => viewReducer.getChatApps(state, true, "STANDARD")) ?? [];
    const selectedAgents = useSelector((state) => chatGPTReducer.getAgentIQToolsAgents(state));
    const optionAgentBlueprint = chatApps?.find((app) => app?.id === option?.value);
    const description = optionAgentBlueprint?.wizard?.description;
    return (React.createElement(Tooltip, { trigger: description ? ["hover"] : [], overlay: description },
        React.createElement(Button, { active: selectedAgents.find((a) => a?.blueprint_id && a.blueprint_id === option?.blueprint_id), className: styles.agentIqToolOptionButton, onClick: () => {
                dispatch(chatGPTReducer.toggleAgentIQToolsAgent(option.value));
                if (deselectDefaults) {
                    dispatch(chatGPTReducer.deselectDefaultAgentIQToolsAgents());
                    if (updateDeselectDefaults) {
                        updateDeselectDefaults(false);
                    }
                }
            } }, option.label)));
};
const AgentIqToolOptionButton = ({ type }) => {
    const dispatch = useDispatch();
    const agentIqTools = useSelector((state) => chatGPTReducer.getAgentIQTools(state));
    const TOOL_DESELECT_GROUP_TYPES = {
        dataset_nlq: "NLQ_TOOL"
    };
    // don't look at user selected blueprints
    const foundIndex = agentIqTools?.findIndex((tool) => {
        // Initial ID match
        if (tool?.id === type?.id) {
            if (type?.execution_id !== undefined && tool?.execution_id !== undefined) {
                return tool?.label === type?.label;
            }
            // The tool doesn't have a blueprint_id
            if (!tool?.blueprint_id) {
                return true;
            }
            // If the blueprint_id is a DEFAULT_AGENTIQ_USECASES, it doesn't appear in the agent select so we dont need to match it
            if (chatGPTReducer.DEFAULT_AGENTIQ_USECASES.includes(tool?.blueprint_id)) {
                return true;
            }
            // Missing the above conditions means it's a user created agent, so we don't want to match it
            return false;
        }
        return false;
    });
    const handleToggleOption = () => {
        let retTools = [...agentIqTools];
        if (foundIndex !== -1) {
            retTools.splice(foundIndex, 1);
            const deselectToolGroupType = TOOL_DESELECT_GROUP_TYPES[type?.value];
            if (deselectToolGroupType) {
                retTools = retTools.filter((tool) => tool?.groupType !== deselectToolGroupType);
            }
        }
        else {
            retTools.push(type);
        }
        dispatch(chatGPTReducer.updateAgentIQTools(retTools));
    };
    const toolGroupParentValue = type?.groupType &&
        Object.keys(TOOL_DESELECT_GROUP_TYPES).find((toolKey) => TOOL_DESELECT_GROUP_TYPES[toolKey] === type?.groupType);
    const hasToolGroupParentSelected = agentIqTools.find((tool) => tool?.value === toolGroupParentValue);
    const disableByGroupType = Boolean(type?.groupType && !hasToolGroupParentSelected);
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { className: styles.agentIqToolOptionButton, active: foundIndex !== -1, onClick: handleToggleOption, disabled: disableByGroupType }, type?.label)));
};
export default AgentIqToolOptionsList;
